import { createContext } from "react";
import type { DynamicForm, FormSubmit } from "api";

export interface DynamicFormContextType {
  form: DynamicForm;
  session: Partial<FormSubmit> & Pick<FormSubmit, "sessionId">;
}

export const DynamicFormContext = createContext<DynamicFormContextType>({
  form: {
    id: 0,
    documentId: "",
    createdAt: new Date(),
    publishedAt: new Date(),
    updatedAt: new Date(),
    title: "",
    intro: [],
    steps: [],
    onSubmit: {
      id: 0,
      useRedirect: false,
    },
  },
  session: { sessionId: "" },
});
